export const getColor = (fromSource: number): string => {
  switch (+fromSource) {
    case 1: // 球友自行注册
      return '#ccc';
    case 2: // 扫码注册
      return '#666';
    case 3: // 球友通讯录导入
      return 'orange';
    case 4: // 球友微信导入
      return '#87d068';
    case 5: // 球友输入手机号导入
      return 'cyan';
    case 6: // 球友会员卡代购导入
      return 'pink';
    case 7: // 馆长自行注册
      return '#ccc';
    case 8: // 馆长通讯录导入会员
      return '#ffbc00';
    case 9: // 馆长通讯录导入球友
      return '#ffbc00';
    case 10: // 馆长聚合营销通讯录导入球友
      return '#ffbc00';
    case 11: // 馆长微信导入
      return '#87d068';
    case 12: // 馆长手动下单
      return '#999999';
    case 13: // 馆长添加内部账号导入
      return '#999999';
    case 14: // 馆长添加包场账号导入
      return '#999999';
    case 15: // 馆长添加教练
      return '#00CC00';
    case 16: // 馆长添加学员
      return '#108ee9';
    case 17: // 馆长添加会员
      return '#00CC00';
    case 18: // 馆长入馆授权导入
      return '#00CC00';
    case 19: // 教练自行注册
      return '#ccc';
    case 20: // 教练添加学员
      return '#00CC00';
    case 21:
      return '#00CC00';
    case 22:
    default:
      return '';
  }

  return '';
};

export const fromSourceList: any = [
  {
    label: '全部',
    value: 0,
  },
  {
    label: '球友自行注册',
    value: 1,
  },
  {
    label: '扫码注册',
    value: 2,
  },
  {
    // label: '球友通讯录导入',
    label: '球友导入',
    value: 3,
  },
  {
    label: '球友微信导入',
    value: 4,
  },
  {
    label: '球友输入手机号导入',
    value: 5,
  },
  {
    label: '球友会员卡代购导入',
    value: 6,
  },
  {
    label: '馆长自行注册',
    value: 7,
  },
  {
    // label: '馆长通讯录导入会员',
    label: '馆长导入会员',
    value: 8,
  },
  {
    // label: '馆长通讯录导入球友',
    label: '馆长导入球友',
    value: 9,
  },
  {
    // label: '馆长聚合营销通讯录导入球友',
    label: '馆长聚合营销导入球友',
    value: 10,
  },
  {
    label: '馆长微信导入',
    value: 11,
  },
  {
    label: '馆长手动下单',
    value: 12,
  },
  {
    label: '馆长添加内部账号导入',
    value: 13,
  },
  {
    label: '馆长添加包场账号导入',
    value: 14,
  },
  {
    label: '馆长添加教练',
    value: 15,
  },
  {
    label: '馆长添加学员',
    value: 16,
  },
  {
    label: '馆长添加会员',
    value: 17,
  },
  {
    label: '馆长入馆授权导入',
    value: 18,
  },
  {
    label: '教练自行注册',
    value: 19,
  },
  {
    label: '教练添加学员',
    value: 20,
  },
  {
    label: '后台创建的账号',
    value: 21,
  },
];

export const fromSourceMap: any = {};

fromSourceList.forEach((el: any) => {
  fromSourceMap[el.value] = el.label;
});

export const getFromSourceText = (fromSource: number): string => fromSourceMap[+fromSource] || '';
// console.log("getFromSourceText", fromSource, fromSourceMap, fromSourceMap[+fromSource]);
